import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import SmartGrabber from '@/views/datagrabber/SmartGrabber';
import Users from '@/views/users/Users';
import TrustedIPs from '@/views/users/TrustedIPs';
import Dashboard from '@/views/dashboard/Dashboard';
import Blank from '@/views/dashboard/Blank';
import BrandPerformance from '@/views/dashboard/BrandPerformance';
import ManageDataset from '@/views/dataset/ManageDataset';
import ChartsReport from '@/views/charts/ChartsReport';
import BigQueryGrabber from "../views/datagrabber/BigQueryGrabber.vue";
// import BigQueryGrabber from "../views/smartgrabber/Index.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        alias: '/home',
    },
    {
        path: '/smartgrabber',
        name: 'SmartGrabber',
        component: SmartGrabber,
    },
    {
        path: '/big-query-grabber',
        name: 'BigQueryGrabber',
        component: BigQueryGrabber,
    },
    // {
    //   path: '/smartgrabber',
    //   name: 'DataGrabber',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "v-data-grabber" */ '@/views/datagrabber/DataGrabber'
    //     ),
    // },
    {
        path: '/users',
        name: 'Users',
        component: Users,
    },
    {
        path: '/trustedips',
        name: 'TrustedIPs',
        component: TrustedIPs,
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        children: [
            {
                path: 'main',
                name: 'Dashboard/Blank',
                component: Blank,
            },
            {
                path: 'brandperformance/:id',
                name: 'Dashboard/BrandPerformance',
                component: BrandPerformance,
            },
        ],
    },
    {
        path: '/brandPerformance/:id?',
        name: 'BrandPerformance',
        props: {name: ''},
        component: () =>
            import(
                /* webpackChunkName: "v-brand-performance" */ '@/views/dashboard/Brand'
                ),
    },
    {
        path: '/businessPerformance/:id?',
        name: 'BusinessPerformance',
        props: {name: ''},
        component: () =>
            import(
                /* webpackChunkName: "v-business-performance" */ '@/views/dashboard/Business'
                ),
    },
    {
        path: '/reports/:id?',
        name: 'Reports',
        props: {name: ''},
        component: () =>
            import(
                /* webpackChunkName: "v-reports" */ '@/views/reports/Reports'
                ),
    },
    {
        path: '/manage-dataset',
        name: 'manage-dataset',
        component: ManageDataset,
    },
    {
        path: '/charts-report',
        name: 'charts-report',
        component: ChartsReport,
    },
    {
        path: '/admin',
        name: 'admin',
        component: () =>
            import(/* webpackChunkName: "v-admin" */ '@/views/admin/Admin'),
        children: [
            {
                path: 'dashboard-management',
                name: 'admin-dashboard-management',
                component: () =>
                    import(
                        /* webpackChunkName: "v-admin-dashboard-management" */ '@/views/admin/DashboardManagement'
                        ),
            },
            {
                path: 'tableau-management',
                name: 'admin-tableau-management',
                component: () =>
                    import(
                        /* webpackChunkName: "v-admin-tableau-management" */ '@/views/admin/TableauManagement'
                        ),
            },
            {
                path: 'tableau-permission',
                name: 'admin-tableau-permission',
                component: () =>
                    import(
                        /* webpackChunkName: "v-admin-tableau-permission" */ '@/views/admin/TableauPermission'
                        ),
            },
            {
                path: 'tableau-identities',
                name: 'admin-tableau-identities',
                component: () =>
                    import(
                        /* webpackChunkName: "v-admin-tableau-identities" */ '@/views/admin/TableauIdentities'
                        ),
            },
            {
                path: 'smartgrabber-management',
                name: 'admin-smartgrabber-management',
                component: () =>
                    import(
                        /* webpackChunkName: "v-admin-smartgrabber-management" */ '@/views/admin/SmartGrabberManagement'
                        ),
            },
            {
                path: 'gbq-management',
                name: 'admin-gbq-management',
                component: () =>
                    import(
                        /* webpackChunkName: "v-admin-gbq-management" */ '@/views/admin/GbqManagement'
                        ),
            },
            {
                path: 'cache-management',
                name: 'admin-cache-management',
                component: () =>
                    import(
                        /* webpackChunkName: "v-admin-cache-management" */ '@/views/admin/CacheManagement'
                        ),
            },
            {
                path: 'exception-logs',
                name: 'admin-exception-logs',
                component: () =>
                    import(
                        /* webpackChunkName: "v-admin-exception-logs" */ '@/views/admin/ExceptionLogs'
                        ),
            },
        ],
    },
    {path: '*', redirect: '/'},
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
